import React from 'react';

interface FeatureSectionProps {
  title: string;
  features: {
    title: string;
    description: string;
  }[];
}

const FeatureSection: React.FC<FeatureSectionProps> = ({ title, features }) => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">{title}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const accentColors = [
              'text-primary-700',
              'text-accent-600', 
              'text-secondary-600',
              'text-primary-700',
              'text-accent-600',
              'text-secondary-600'
            ];
            return (
              <div 
                key={index} 
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
              >
                <h3 className={`text-xl font-semibold mb-3 ${accentColors[index % accentColors.length]}`}>
                  {feature.title}
                </h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
